var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "container-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Filter Order Report")]), _c('div', {
    staticClass: "content"
  }, [_vm.branchs.length > 0 ? _c('div', {
    staticClass: "split"
  }, [_vm._m(0), _c('multiselect', {
    attrs: {
      "options": _vm.branchs,
      "label": "name",
      "track-by": "id",
      "multiple": false,
      "taggable": true,
      "placeholder": "Search Branch",
      "open-direction": "bottom",
      "show-no-results": false,
      "internal-search": false,
      "clear-on-select": false,
      "close-on-select": true,
      "options-limit": 100
    },
    on: {
      "search-change": _vm.debouncedOnSearchBranchs,
      "input": _vm.onBranchSelected
    },
    model: {
      value: _vm.branchId,
      callback: function ($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })], 1) : _vm._e(), _vm.data.orderStatus.length > 0 ? _c('div', {
    staticClass: "split"
  }, [_vm._m(1), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.customerGroupId,
      expression: "body.customerGroupId"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "customerGroupId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Customer Group")]), _vm._l(_vm.data.customerGroups, function (customerGroup, customerGroupIndex) {
    return _c('option', {
      key: customerGroup.id,
      domProps: {
        "value": customerGroup.id
      }
    }, [_vm._v(" " + _vm._s(customerGroup.name) + " ")]);
  })], 2)]) : _vm._e(), _c('div', {
    staticClass: "split"
  }, [_vm._m(2), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideCustomerTextbox,
      expression: "clickOutsideCustomerTextbox"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.body.customerName,
      expression: "body.customerName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search Customer"
    },
    domProps: {
      "value": _vm.body.customerName
    },
    on: {
      "click": function ($event) {
        _vm.isCustomerDropdown = true;
      },
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "customerName", $event.target.value);
      }, _vm.debouncedOnSearchCustomers]
    }
  }), _vm.body.customerId ? _c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "position": "absolute",
      "top": "13px",
      "right": "16px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onUnselectCustomer
    }
  }) : _vm._e(), _vm.isCustomerDropdown ? _c('div', {
    staticClass: "block-customer-dropdown",
    staticStyle: {
      "top": "44px"
    }
  }, [_vm._l(_vm.data.customers, function (customer, customerIndex) {
    return _c('div', {
      key: customer.id,
      staticClass: "row p6 customer-item",
      on: {
        "click": function ($event) {
          return _vm.onSelectCustomer(customerIndex);
        }
      }
    }, [_vm._v(" " + _vm._s((customer === null || customer === void 0 ? void 0 : customer.bpName) && (customer === null || customer === void 0 ? void 0 : customer.bpName) || `${customer.firstName} ${customer.lastName}`) + " ")]);
  }), !_vm.data.customers.length ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "padding": "10px"
    }
  }, [_vm._v(" No Customer ")]) : _vm._e()], 2) : _vm._e()])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(3), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.code,
      expression: "body.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "BP code, E-com code"
    },
    domProps: {
      "value": _vm.body.code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "code", $event.target.value);
      }
    }
  })])]), _vm.data.paymentMethods.length > 0 ? _c('div', {
    staticClass: "split"
  }, [_vm._m(4), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.paymentMethodId,
      expression: "body.paymentMethodId"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "paymentMethodId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Payment Method")]), _vm._l(_vm.data.paymentMethods, function (paymentMethod, index) {
    return _c('option', {
      key: (paymentMethod, index),
      domProps: {
        "value": paymentMethod.id
      }
    }, [_vm._v(" " + _vm._s(paymentMethod.name) + " ")]);
  })], 2)]) : _vm._e(), _c('div', {
    staticClass: "split"
  }, [_vm._m(5), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.minTotal,
      expression: "body.minTotal"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Input minimum price"
    },
    domProps: {
      "value": _vm.body.minTotal
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "minTotal", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(6), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.maxTotal,
      expression: "body.maxTotal"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Input maximum price"
    },
    domProps: {
      "value": _vm.body.maxTotal
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "maxTotal", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(7), _c('date-picker', {
    attrs: {
      "value-type": "format",
      "placeholder": "Select date",
      "format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.body.startDate,
      callback: function ($$v) {
        _vm.$set(_vm.body, "startDate", $$v);
      },
      expression: "body.startDate"
    }
  })], 1), _c('div', {
    staticClass: "split"
  }, [_vm._m(8), _c('date-picker', {
    attrs: {
      "value-type": "format",
      "placeholder": "Select date",
      "format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.body.endDate,
      callback: function ($$v) {
        _vm.$set(_vm.body, "endDate", $$v);
      },
      expression: "body.endDate"
    }
  })], 1), _vm.data.orderStatus.length > 0 ? _c('div', {
    staticClass: "split"
  }, [_vm._m(9), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.orderStatus,
      expression: "body.orderStatus"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "orderStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Order Status")]), _vm._l(_vm.data.orderStatus, function (orderStatus, index) {
    return _c('option', {
      key: (orderStatus, index),
      domProps: {
        "value": orderStatus.id
      }
    }, [_vm._v(" " + _vm._s(orderStatus.name) + " ")]);
  })], 2)]) : _vm._e(), _vm.providers.length > 0 ? _c('div', {
    staticClass: "split"
  }, [_vm._m(10), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.provider,
      expression: "body.provider"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "provider", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.providers, function (orderStatus, index) {
    return _c('option', {
      key: (orderStatus, index),
      domProps: {
        "value": orderStatus.id
      }
    }, [_vm._v(" " + _vm._s(orderStatus.name) + " ")]);
  }), 0)]) : _vm._e(), _vm.deliveryStatuses.length > 0 ? _c('div', {
    staticClass: "split"
  }, [_vm._m(11), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.deliveryStatusId,
      expression: "body.deliveryStatusId"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "deliveryStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.deliveryStatuses, function (deliveryStatus, index) {
    return _c('option', {
      key: (deliveryStatus, index),
      domProps: {
        "value": deliveryStatus.id
      }
    }, [_vm._v(" " + _vm._s(deliveryStatus.name) + " ")]);
  }), 0)]) : _vm._e()]), _c('div', {
    staticClass: "col-12 pv6 mb12"
  }, [_c('div', [!_vm.isGenerating ? _c('button', {
    staticClass: "btn btn-theme-grey-light btn-xs btn-create",
    on: {
      "click": function ($event) {
        return _vm.generateReport('');
      }
    }
  }, [_c('span', [_vm._v("Generate")])]) : _c('button', {
    staticClass: "btn btn-info btn-xs btn-create"
  }, [_c('span', [_vm._v("Generating...")])])])])])]), _vm.isGenerated ? _c('div', {
    staticClass: "form-container mt26"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "hidden": ""
    }
  }), _c('header', {
    staticClass: "navbar r-navbar"
  }, [_vm._m(12), _vm.table.headers.length > 0 && _vm.table.body.length > 0 ? _c('div', {
    staticClass: "con-search-btn",
    staticStyle: {
      "position": "unset"
    }
  }, [!_vm.isExporting ? _c('button', {
    staticClass: "btn btn-theme-grey-light btn-xs btn-create",
    on: {
      "click": function ($event) {
        return _vm.generateReport('export');
      }
    }
  }, [_vm._v(" Export File ")]) : _c('button', {
    staticClass: "btn btn-theme-grey-light btn-xs btn-create"
  }, [_c('span', [_vm._v("Exporting...")])])]) : _vm._e()]), _c('div', {
    staticClass: "table-control p12"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l(_vm.table.headers, function (item) {
    return _c('th', {
      staticClass: "table-header"
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _c('tbody', _vm._l(_vm.table.body, function (item, index) {
    return _c('tr', {
      key: (item, index),
      staticClass: "hover-list"
    }, _vm._l(item, function (key, keyIndex) {
      return _c('td', [_vm._v(" " + _vm._s(keyIndex == 'Updated Date' || keyIndex == 'Ordered Date' ? _vm.ExcelDateToJSDate(key) : key) + " ")]);
    }), 0);
  }), 0)])])]) : _vm._e(), _vm.table.body.length == 1 ? _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "txt-center",
    staticStyle: {
      "line-height": "490px"
    }
  }, [_vm._v("No Report")])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Select Branch :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Customer Group :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Customer Name :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Code :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Payment Method :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Min Price :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Max Price :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Start Date :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("End Date :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Order Status :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Provider :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Delivery Status :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ul-xl"
  }, [_c('div', {
    staticClass: "ul-xl-li"
  }, [_vm._v("Reports")])]);

}]

export { render, staticRenderFns }